/**
 * ZUNO — shareService.js
 * Compartilhamento de viagem em tempo real
 * Gera link público com token único para familiar acompanhar
 */
import { doc, setDoc, serverTimestamp, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

function gerarToken() {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, "0")).join("");
}

/**
 * Cria ou atualiza link de compartilhamento para uma corrida.
 * Retorna URL pública para enviar.
 */
export async function criarShareLink({ rideId, passageiroId, passageiroNome }) {
  const token = gerarToken();
  await setDoc(doc(db, "share_links", token), {
    rideId,
    passageiroId,
    passageiroNome,
    criadoEm: serverTimestamp(),
    expiraEm: Timestamp.fromDate(new Date(Date.now() + 4 * 60 * 60 * 1000)), // 4h
  });
  const base = window.location.origin;
  return `${base}/acompanhar/${token}`;
}
